(() => {
  const PRODUCT_IMAGE = 'https://cdn.shopify.com/s/files/1/0787/4402/7288/files/c3cd408b-f689-4e14-b710-96a5a9ee328e.png?v=1789168068';
  const RITUAL_IMAGE = 'https://cdn.shopify.com/s/files/1/0787/4402/7288/files/veoness-skindion-dispositivo-rosa.png';
  const PRICE = '39 €';
  const COMPARE_PRICE = '99 €';
  const PRICE_CENTS = '3900';

  function isSkindion() {
    return !!document.querySelector('.skindion-page');
  }

  function setText(selector, text) {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function makeComparePrice(extraClass) {
    const del = document.createElement('del');
    del.className = 'skd-compare-price' + (extraClass ? ' ' + extraClass : '');
    del.textContent = COMPARE_PRICE;
    del.style.color = '#8a8a8a';
    del.style.fontWeight = '700';
    del.style.marginLeft = '10px';
    del.style.fontSize = '0.58em';
    del.style.verticalAlign = 'middle';
    return del;
  }

  function syncPrice() {
    document.querySelectorAll('.mpp__plan[data-plan]').forEach((plan) => {
      plan.setAttribute('data-price-money', PRICE);
      plan.setAttribute('data-price-cents', PRICE_CENTS);
    });

    document.querySelectorAll('.mpp__precio').forEach((current) => {
      if (current.textContent.trim() !== PRICE) current.textContent = PRICE;
      const host = current.parentElement;
      if (host && !host.querySelector(':scope > .skd-compare-price')) host.appendChild(makeComparePrice('skd-compare-price--hero'));
    });

    document.querySelectorAll('.mpp__plan-repo-control').forEach((el) => {
      if (el.textContent.trim() !== 'Una sola compra de 39 €.') el.textContent = 'Una sola compra de 39 €.';
    });

    document.querySelectorAll('[data-sticky-select] option').forEach((option) => {
      if (/SKINDION|CONTORNO 5/i.test(option.textContent || '')) option.textContent = 'SKINDION · 39 €';
    });
    document.querySelectorAll('[data-sticky-sub], .mpp__sticky-sub').forEach((el) => {
      if (/59\s*€|39\s*€|pago único/i.test(el.textContent || '')) el.textContent = '39 € · Pago único';
    });

    document.querySelectorAll('.vs-offer__intro strong').forEach((el) => {
      if (/una sola compra de\s*(?:59|39)\s*€/i.test(el.textContent || '')) el.textContent = 'Una sola compra de 39 €.';
    });
    document.querySelectorAll('.vs-offer__price').forEach((wrap) => {
      const current = wrap.querySelector('strong');
      if (current && current.textContent.trim() !== PRICE) current.textContent = PRICE;
      if (current && !wrap.querySelector('.skd-compare-price')) current.insertAdjacentElement('afterend', makeComparePrice('skd-compare-price--offer'));
    });

    document.querySelectorAll('.pct__cell--skin').forEach((cell) => {
      const price = cell.querySelector('.pct__price');
      const sub = cell.querySelector('.pct__price-sub');
      if (price && price.textContent.trim() !== PRICE) price.textContent = PRICE;
      if (sub && sub.textContent.trim() !== 'Antes 99 € · Pago único') sub.textContent = 'Antes 99 € · Pago único';
      if (price && !cell.querySelector('.skd-compare-price--comparison')) {
        const del = makeComparePrice('skd-compare-price--comparison');
        del.style.display = 'inline-block';
        del.style.fontSize = '0.78em';
        price.insertAdjacentElement('afterend', del);
      }
    });
  }

  function cleanOffer() {
    document.querySelectorAll('.vs-offer__intro').forEach((intro) => {
      const p = intro.querySelector('p:not(.vs-offer__eyebrow)');
      if (p) p.textContent = 'Tu dispositivo Skindion Rosa con el Método VEONESS Contorno 5 para una rutina facial sencilla de 5 minutos al día.';
    });

    document.querySelectorAll('.vs-offer__list li').forEach((li) => {
      const t = (li.textContent || '').toLowerCase();
      if (t.includes('gel conductor') || t.includes('gel 50') || t.includes('50 g')) li.remove();
    });

    const list = document.querySelector('.vs-offer__list');
    if (list && !/dispositivo skindion/i.test(list.textContent || '')) {
      const li = document.createElement('li');
      li.innerHTML = '<span class="vs-offer__check">✓</span><span><strong>Dispositivo Skindion</strong> Rosa</span>';
      list.prepend(li);
    }

    document.querySelectorAll('.vs-offer__muted, .vs-offer__green, .vs-offer__pills span, .vs-offer__pricebox p, .vs-offer__more').forEach((el) => {
      let t = (el.textContent || '').trim();
      if (!t) return;
      t = t.replace(/30 días para devoluciones/gi, '60 días para devoluciones')
           .replace(/30 días de devolución/gi, '60 días de devolución')
           .replace(/30 días de prueba/gi, '60 días de prueba')
           .replace(/\s*[·|•]?\s*Sin suscripción/gi, '')
           .replace(/\s*[·|•]?\s*Sin cargos recurrentes/gi, '')
           .replace(/\s*[·|•]\s*$/g, '')
           .trim();
      if (el.textContent !== t) el.textContent = t;
      if (!t) el.style.display = 'none';
    });
  }

  function cleanHero() {
    setText('.mpp__desc', 'Skindion es un dispositivo facial de microcorriente diseñado para una rutina de 5 minutos al día. Deslízalo suavemente por frente, cejas, pómulos, contorno de ojos, mandíbula y cuello siguiendo el Método VEONESS Contorno 5.');
    document.querySelectorAll('.mpp__plan-sessions-gel').forEach((el) => { el.style.display = 'none'; });
    document.querySelectorAll('[data-repo-line]').forEach((el) => {
      if (el.textContent !== 'Dispositivo Skindion Rosa, manual + vídeo de uso.') el.textContent = 'Dispositivo Skindion Rosa, manual + vídeo de uso.';
    });
  }

  function cleanMechanism() {
    setText('.mpp__mechanism-lead', 'Skindion utiliza microcorriente facial para acompañar una rutina de cuidado enfocada en frente, pómulos, contorno de ojos, mandíbula y cuello.');
    setText('.mpp__mechanism-copy', 'Utiliza la intensidad que te resulte cómoda y desliza el dispositivo lentamente siguiendo el Método VEONESS Contorno 5.');
  }

  function replaceObsoleteImages() {
    document.querySelectorAll('img').forEach((img) => {
      const src = img.getAttribute('src') || '';
      const srcset = img.getAttribute('srcset') || '';

      if (src.includes('veoness-contorno5-59-euros.png') || srcset.includes('veoness-contorno5-59-euros.png')) {
        img.src = PRODUCT_IMAGE;
        img.removeAttribute('srcset');
        img.alt = 'Dispositivo facial Skindion Rosa';
        img.removeAttribute('data-zoom');
      }

      if (src.includes('veoness-ritual-4-pasos-2-gel.jpg') || srcset.includes('veoness-ritual-4-pasos-2-gel.jpg')) {
        img.src = RITUAL_IMAGE;
        img.removeAttribute('srcset');
        img.alt = 'Dispositivo Skindion preparado para la rutina';
      }
    });

    document.querySelectorAll('[data-zoom], a[href]').forEach((el) => {
      const zoom = el.getAttribute('data-zoom') || '';
      const href = el.getAttribute('href') || '';
      if (zoom.includes('veoness-contorno5-59-euros.png')) el.setAttribute('data-zoom', PRODUCT_IMAGE);
      if (href.includes('veoness-contorno5-59-euros.png')) el.setAttribute('href', PRODUCT_IMAGE);
    });
  }

  function isReviewNode(node) {
    const el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    return !!el?.closest('.skr-wrap, .ptc, [class*="review"], [id*="review"], blockquote, [data-review]');
  }

  function cleanBusinessText() {
    const root = document.querySelector('.skindion-page');
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT','STYLE','NOSCRIPT','TEXTAREA','CODE','PRE'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        if (isReviewNode(node)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let t = node.nodeValue;
      if (!t || !t.trim()) return;
      const original = t;

      t = t.replace(/30 días para devoluciones/gi, '60 días para devoluciones')
           .replace(/30 días de devolución/gi, '60 días de devolución')
           .replace(/30 días de prueba/gi, '60 días de prueba')
           .replace(/Garantía de resultados de 30 días/gi, 'Garantía de 60 días')
           .replace(/Garantía de 30 días/gi, 'Garantía de 60 días')
           .replace(/\s*[·|•]?\s*Sin suscripción/gi, '')
           .replace(/\s*[·|•]?\s*Sin cargos recurrentes/gi, '')
           .replace(/Gel conductor portátil 50 g/gi, '')
           .replace(/Gel conductor de 50 g/gi, '')
           .replace(/Gel conductor de 50g/gi, '')
           .replace(/con gel de 50 g/gi, '')
           .replace(/con gel de 50g/gi, '')
           .replace(/Aplica el gel conductor/gi, 'Prepara la piel')
           .replace(/¿Por qué necesito gel conductor\?/gi, '¿Cómo preparo la piel antes de usar Skindion?')
           .replace(/59\s*€/g, PRICE);

      if (t !== original) node.nodeValue = t.replace(/\s{2,}/g, ' ');
    });

    document.querySelectorAll('.skindion-page details, .skindion-page .faq-item, .skindion-page [class*="faq"]').forEach((item) => {
      if (isReviewNode(item)) return;
      const text = (item.textContent || '').toLowerCase();
      if (text.includes('gel conductor')) {
        const q = item.querySelector('summary, .faq-question, [class*="question"]');
        const a = item.querySelector('.faq-answer, [class*="answer"], .accordion__content, [class*="content"]');
        if (q) q.textContent = '¿Cómo preparo la piel antes de usar Skindion?';
        if (a) a.innerHTML = '<p>Usa Skindion siguiendo las instrucciones del dispositivo y ajusta la intensidad a una sensación cómoda. La piel debe estar limpia antes de comenzar la rutina.</p>';
      }
    });
  }

  function cleanGuarantee() {
    const section = document.querySelector('.mpp__guarantee, .vs-guarantee, [data-guarantee-section]');
    if (!section) return;
    section.querySelectorAll('p, small, .subtitle, .caption').forEach((el) => {
      const t = (el.textContent || '').trim();
      if (/una compra de\s*(?:59|39)/i.test(t) || /sin suscripci/i.test(t)) el.remove();
    });
  }

  function run() {
    if (!isSkindion()) return;
    cleanHero();
    cleanMechanism();
    cleanOffer();
    replaceObsoleteImages();
    cleanBusinessText();
    syncPrice();
    cleanGuarantee();
  }

  function boot() {
    run();
    [100, 350, 800, 1500, 2600].forEach((ms) => setTimeout(run, ms));
    const root = document.querySelector('.skindion-page');
    if (!root) return;
    let timer;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(run, 35);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src','srcset','href'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
